import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { DayOfRaceDate } from '@cds/betting-offer/domain-specific/horse-racing';
import { Observable } from 'rxjs';

import { DayOfRaceModel } from '../../../horse-racing-shared/model/day-of-race.model';
import { HorseRacingApiService } from '../../../horse-racing-shared/services/horse-racing-api.service';

@Injectable()
export class HorsesTomorrowResolver {
    constructor(private apiService: HorseRacingApiService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<DayOfRaceModel | undefined> {
        return this.apiService.getDayOfRaceFixtures(DayOfRaceDate.Tomorrow);
    }
}
